import {createApi} from '@reduxjs/toolkit/query/react'
import {baseQuery} from '../base-query'

export interface CandidateSearchResult {
  id: string
  firstName: string
  lastName: string
  branch?: string
  last4SSN?: string
  city?: string
  state?: string
}

export interface CompanySearchResult {
  id: string
  name: string
  city?: string
  state?: string
}

export interface JobOrderSearchResult {
  id: string
  orderNumber: string
  companyName?: string
  status?: string
}

export interface ServiceOrderSearchResult {
  id: string
  orderNumber: string
  companyName?: string
  companyStatus?: string
  mspStatus?: string
}

export interface GlobalSearchResponse {
  candidates: CandidateSearchResult[]
  companies: CompanySearchResult[]
  jobOrders: JobOrderSearchResult[]
  serviceOrders: ServiceOrderSearchResult[]
}

export interface GlobalSearchRequest {
  query: string
  limit?: number
}

export const globalSearchApi = createApi({
  reducerPath: 'globalSearchApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    globalSearch: builder.query<GlobalSearchResponse, GlobalSearchRequest>({
      query: ({query, limit = 5}) => ({
        url: '/api/search',
        method: 'GET',
        params: {query, limit},
      }),
      keepUnusedDataFor: 0,
    }),
  }),
})

export const {useLazyGlobalSearchQuery} = globalSearchApi
